export default "__VITE_ASSET__BQOJz$yA__"